import {readByXzx} from './readByXzx.js';
import {readByHs} from './readByHs.js';
import {readBySs} from "./readBySs";
import {readByHkws} from "./readByHkws";
/**
 * 身份证阅读器接口
 * @param {*} type 阅读器类型（xzx：新中新  hs：华视）
 * @param {*} readPort 阅读器接口端口
 * @param {*} mode 读取模式（手动/自动）
 * @param {*} callback 回调的函数
 */

export const readOption = (type, readPort, mode, callback) => {
  console.log(type)
    switch (type) {
      case 'xzx': 
        readByXzx(readPort, mode, callback);
        break;
      case 'hs':
        readByHs(readPort, mode, callback);
        break;
      case 'ss_628100':
        readBySs(readPort, mode, callback);
        break;
      case 'DS_K56A0_D':
        readByHkws(readPort, mode, callback);
        break;
      default:
        readByXzx(readPort, mode, callback);
        break;
    }
  }


// WEBPACK FOOTER //
// ./components/yxxc/readCard/index.js